module.exports = __webpack_public_path__ + "img/myExplain.ff16cb25.png";